import {Component, HostListener} from '@angular/core';
import {AuthService} from "../../service/auth.service";
import {StatisticsService} from "../../service/statistics.service";

@Component({
  selector: 'app-sidebar-list',
  templateUrl: './sidebar-list.component.html',
  styleUrls: ['./sidebar-list.component.css']
})
export class SidebarListComponent {

  constructor(private authService: AuthService, private statisticService: StatisticsService) {
  }

  isLoggedIn() {
    return this.authService.isLoggedIn();
  }

  isAdmin() {
    return this.authService.isAdmin();
  }

  isModerator() {
    return this.authService.isModerator();
  }

  isSuperAdmin() {
    return this.authService.isSuperAdmin();
  }

  closeNavMenuAfterClickOnLink() {
    if (this.isSmallScreen()) {
      this.statisticService.openNavbarMenu();
    }
  }

  @HostListener('window:resize')
  isSmallScreen(): boolean {
    return window.innerWidth <= 1115;
  }
}
